const blockmonitor = { 
    'blockmonitor.title': '区块丢失情况统计',
    'blockmonitor.table.Round': '轮次', 
    'blockmonitor.table.lostBlockNum': '丢失区块数量',
    'blockmonitor.table.nodeName': '节点名称 ',
    'blockmonitor.table.nodeAddress': '节点地址', 

    'blockmonitor.tip1': '共找到',
    'blockmonitor.tip2': '个轮次 ', 
    'blockmonitor.tip7': '下表显示了每一轮的块丢失情况。如果矿工连续超过 30 轮丢块，它将被 HPBNode 委员会踢出。', 
}
export default blockmonitor;
